import enLocale from '@onesait/ods/lib/locale/lang/en'

export default {
  ...enLocale,
  'login': {
    'title': 'Login',
    'user': 'Username',
    'password': 'Password',
    'submitButton': 'Send',
    'rules': {
      'user': 'Please, type a user name',
      'password': 'Please, type a password'
    },
    'logging': 'Loading...',
    'loginErrorTitle': 'Validation Error',
    'loginError': 'Invalid user or wrong password.',
    'forgotPassword': 'Forgot your password?',
    'keepMeLogged': 'Keep me logged in',
    'login': 'Login',
    'footerLinks': ['faq', 'terms', 'conditions']
  },
  'password': {
    'title': 'Reset password',
    'message': 'Type your account\'s email to proceed',
    'email': 'Email',
    'submitButton': 'Submit',
    'goBack': 'Go back',
    'error': 'Email not found',
    'sending': 'Sending...',
    'rules': {
      'email': 'Email not found'
    },
    'emailSubmitted': 'We\'ve sent an email with the instructions to reset your password to: ',
    'done': 'Finish',
    'emailError': 'We can\'t find any account with this email:'
  },
  'breadcrumb': {
    'dashboard': 'Dashboard',
    'predictiveModels': 'Predictive Models',
    'createModel': 'Create Model',
    'selectModel': 'Select Model',
    'parksAndGardens': 'Parks and Gardens',
    'mapCompare': 'Compare',
    'environment': 'Environment',
    'mobility': 'Mobility',
    'autobuses': 'Bus',
    'Autobuses': 'Bus',
    'bike': 'Bike',
    'parking': 'Parking',
    'visualization': 'Visualization',
    'cruises': 'Cruises Control',
    'cruisesRealTime': 'Real Time',
    'cruisesHistoric': 'Historic',
    'profile': 'Profile',
    'crm': 'CRM Citizen',
    'instalacionesdeportivas': 'Sports facilities',
    'contaminaciónenelaire': 'Air pollution'
  },
  'notifications': {
    'popoverTitle': 'Notifications'
  },
  'inicio': 'Start',
  'fin': 'End',
  'nettle': 'Nettle',
  'noiseContaminationCoef': 'Noise Contamination Coef',
  'olive': 'Olive',
  'grass': 'Grass',
  'chenopodiaceaeAmaranthaceae': 'Amaranthaceae',
  'daily': 'Today',
  'today': 'Today',
  'alerts': 'Alerts',
  'alert': 'Alert',
  'Alert': 'Alert',
  'campaigns': 'Campaigns',
  'campaign': 'Campaign',
  'historic': 'Historic',
  'social networks': 'Social Networks',
  'timeline': 'Timeline',
  'trends': 'Trends',
  'actives': 'Actives',
  'inactives': 'Inactives',
  'nivel': 'level',
  'Weather': 'Meteorology',
  'occupationRateSensorZones': 'Occupation Zones',
  'occupationRateParking': 'Ocuppation Parking',
  'Viento': 'wind',
  'Presión': 'pressure',
  'Temperatura': 'temperature',
  'Precipitación': 'precipitation',
  'Without variation': 'Sin variación',
  'Gestión': 'Management',
  'Modelos Predictivos': 'Predictive Models',
  'Emergencias y Seguridad': 'Emergency and Security',
  'Iluminación y Ef.energética': 'Illumination',
  'Parques y Jardines': 'Parks and Gardens',
  'Medioambiente y Meteorología': 'Environment and Metereology',
  'Medioambiente y Meteorologia': 'Environment and Metereology',
  'environment': 'Environment',
  'Hosteleria': 'Hostelry',
  'Gestión de residuos urbanos': 'Urban waste management',
  'Movilidad y Transporte': 'Mobility and Transport',
  'Movilidad y transporte': 'Mobility and Transport',
  'Comercio': 'Commerce',
  'Salud y Bienestar': 'Health & Wellness',
  'Ocio y Cultura': 'Leisure and Culture',
  'Medioambiente': 'Environment',
  'Educación': 'Education',
  'Deporte': 'Sport',
  'mobilityAndTransportation': 'Mobility and Transport',
  'Vivienda y Urbanismo': 'Housing and Urbanism',
  'Limpieza y Gestión de residuos': 'Waste Cleaning and Management',
  'comparar': 'compare',
  'Modelos predictivos': 'Predictive Models',
  'Creación de modelo': 'Create model',
  'no data': 'no data',
  'no data alerts today': 'There are no alerts for today. Try it again later',
  'no data alerts week': 'There are no alerts for the last 7 days. Try it again later',
  'no data campaign active': 'There are no active campaigns. Try it again later',
  'no data campaign inactive': 'There are no inactive campaigns. Try it again later',
  'no data social timeline': 'We can not upload social network data at this time. Try it again later',
  'no data social trends': 'We can not upload "Trends" data at this time. Try it again later',
  'no data kpi': 'There are no KPIs for the selected module. Try it again later.',
  'no data kpi parkingPanel': 'Select a parking panel for more information',
  'no data kpi chart select': 'Select a KPI to show the graph.',
  'no data kpi chart': 'There are no KPIs for the selected module. Try it again later.',
  'no data kpi chart suficient': 'There are not enough data to form the graph.',
  'no data kpi compare': 'There is not enough data to compare',
  'noVisualizationData': 'There are no visualizations to show',
  'noResults': 'No results',
  'tipo': 'type',
  'area': 'Area',
  'hora': 'hour',
  'titulo': 'title',
  'periodo': 'period',
  'Detalle de la alerta': 'Alert Details',
  'Último día': 'Last Day',
  'Últimos 7 Días': 'Last 7 days',
  'Últimos 30 Días': 'Last 30 days',
  'Últimos 12 meses': 'Last 12 months',
  'Últimos 5 años': 'Last 5 years',
  'All': 'All',
  'AeroAllergen': 'Aero Allergen',
  'AirQuality': 'Air Cuality',
  'noiseLevelKpi': 'Noise Level',
  'Ground': 'Ground',
  'Incidence': 'Incidence',
  'incidence': 'Incidence',
  'Irrigation': 'Irrigation',
  'CO2Absorption': 'CO2 Absorption',
  'grain/m3': 'g/m³',
  'µg/m3': 'µg/m³',
  'g/m3': 'g/m³',
  'm3': 'm³',
  'minimum': 'Minimum',
  'maximum': 'Maximum',
  'city': 'City',
  'Selected Element': 'Selected element',
  'environment-and-meteorology': 'Environment and Meteorology',
  'chart': 'Chart',
  'Throw': 'Throw',
  'Nivel 0': 'Level 0',
  'Nivel 1': 'Level 1',
  'Nivel 2': 'Level 2',
  'Nivel 3': 'Level 3',
  'nivel 0': 'Level 0',
  'nivel 1': 'Level 1',
  'Activa': 'Active',
  'activo': 'Active',
  'inactivo': 'Inactive',
  'Inactiva': 'Inactive',
  'Actualizar': 'Update',
  'Lanzar procedimiento según nivel': 'Launch procedure according to level',
  'Desde aqui puedes lanzar los procedimientos asociados al nivel de esta campaña sin tener que modificar su actual nivel.': 'From here you can launch the associated procedures at the level of this campaign without having to modify its current level.',
  'Calendar': 'Calendar',
  '¿Necesitas ayuda?': 'Need help?',
  'Puedes contactar con el equipo de soporte técnico SmartCities de las siguientes maneras:': 'You can contact the SmartCities technical support team in the following ways:',
  'teléfono': 'telephone',
  'correo': 'email',
  'Notificaciones': 'Notifications',
  'Mi perfil': 'My profile',
  'Cerrar sesión': 'Log out',
  'totalCO2Absorption': 'CO2 Absorption',
  'averageIncidentResolutionTime': 'Average Incident Resolution Time',
  'totalIncidences': 'Total Incidences',
  'units': '',
  'savingsWaterConsumption': 'Savings Water Consumption',
  'waterConsumption': 'Water Consumption',
  'irrigationAverageTime': 'Irrigation Average Time',
  'sprinklerDamaged': 'Sprinkler Damaged',
  'sprinklerTotal': 'Sprinkler Total',
  'activationsIrrigationSystem': 'Activations Irrigation System',
  'savingsAmountWaterConsumption': 'Savings Amount Water Consumption',
  'amountWaterConsumption': 'Amount Water Consumption',
  'fallenTreesOrBranches': 'Fallen Trees Or Branches',
  'totalResolvedIncidences': 'Total Resolved Incidences',
  'alertsByPlague': 'Alerts By Plague',
  'co2AbsorptionByTreeSpecies': 'CO2 Absorption By Tree Species',
  'co2AbsorptionByBushesAndGardens': 'CO2 Absorption By Bushes And Gardens',
  'Meteorología': 'Meteorology',
  'Calidad de Aire': 'Air Quality',
  'Nivel de Ruido': 'Noise level',
  'EligeCategoría': 'Choose Category',
  'Seleccionar': 'Select',
  'volverlistadoalertas': 'return alert list',
  'volverlistadocampanias': 'return campaigns list',
  'Informacióndeparques': 'General park information',
  'InfoParques': 'General park information',
  'infoParques': 'General park information',
  'Informacióndesuelo': 'Ground information',
  'AreadeInfluencia': 'Area of influence',
  'Buscarenmapa': 'Search on map',
  'Incidencias': 'incidences',
  'Contadores': 'Counter',
  'Electrovalvulas': 'Solenoid valves',
  'Detalle de la incidencia': 'Incidence Details',
  'Tienes': 'Have',
  'alertas críticas': 'critical alerts',
  'alerta crítica': 'critical alert',
  'Visualización': 'Visualization',
  'cargar': 'load',
  'cargar visualizaciones': 'load visualizations',
  'cancelar': 'cancel',
  'actualizar': 'update',
  'occupationRate': 'occupation rate',
  'availableSpot': 'available spot',
  'occupiedSpot': 'occupied spot',
  'parkNoPayment': 'park no payment',
  'park120min': 'park 120 min',
  'park60min': 'park 60 min',
  'park30min': 'park 30 min',
  'parkLimitExceded': 'park limit  exceded',
  'usesOfApp': 'uses of app',
  'fails': 'fails',
  'pickaday': 'Pick a day',
  'startdate': 'Start date',
  'enddate': 'End date',
  'totalBikes': 'Total Bikes',
  'freeBikes': 'Free Bikes',
  'bike': 'Bike',
  'bikes': 'Bikes',
  'Bicicletas': 'Bikes',
  'Autobuses': 'Bus',
  'busRealTime': 'Bus',
  'fleetRealTime': 'Fleets',
  'parking': 'Parking',
  'panelParking': 'Panel Parking',
  'parkingPanel': 'Panel Parking',
  'sensorZones': 'Sensor Zones',
  'busStop': 'Bus Stop',
  'busLine': 'Bus Line',
  'users': 'Users',
  'roundNoStop': 'Round No Stop',
  'stops': 'Stops',
  'usersByBusStop': 'Users by Bus Stop',
  'timeBetweenBusStop': 'Time Between Bus Stop',
  'rounds': 'Rounds',
  'paymentsByCard': 'Payments by Card',
  'totalUsers': 'Total Users',
  'paymentsByCash': 'Payments by Cash',
  'timeByRound': 'Time By Round',
  'paymentsByMobileEmv': 'Payments by Mobile Emv',
  'usersByRound': 'Users by Round',
  'busesUsed': 'Buses Used',
  'municipalServices': 'Municipal Services',
  'cruises': 'crusies',
  'Flotas': 'Crusies',
  'state': 'state',
  'speed': 'speed',
  'description': 'description',
  'createDate': 'Create Date',
  'createTime': 'Create Time',
  'cerrar': 'close',
  'solicitudes': 'applications',
  'liters': 'liters',
  'kmrecorrido': 'Km traveled',
  'kmahorrados': 'km saved',
  'consumomedio': 'Average consumption',
  'consumototal': 'Total consumption',
  'centralidadfuncional': 'Centrality Index',
  'eficienciamediaconductores': 'Average driver efficiency',
  'kmemcimavelocidadpermitida': 'Km over allowed speed',
  'fallosdevehiculo': 'Vehicle failures',
  'consumption': 'consumption',
  'avgConsumption': 'average consumption',
  'solicitations': 'solicitations',
  'citizens': 'citizens',
  'resolutionPeriod': 'resolution Period',
  'slopesSolicitations': 'slopes Solicitations',
  'averagePerThousandPeople': 'slopes Solicitations',
  'presenceSolicitations': 'presence Solicitations',
  'appSolicitations': 'app Solicitations',
  'totalSolicitations': 'total Solicitations',
  'webSolicitations': 'web Solicitations',
  'resolvedSolicitations': 'resolved Solicitations',
  'availableProcedure': 'available Procedure',
  'electronicsNotifications': 'electronics Notifications',
  'verageComplaintsConsultationsCitizen': 'verage Complaints Consultations Citizen',
  'percentageRegisteredCitizens': 'percentage RegisteredCitizens',
  'registeredCitizens': 'registered Citizens',
  'postMailNotifications': '(post-Mail) Notifications',
  'smsNotifications': '(sms) Notifications',
  'predictive models': 'Predictive models',
  'SELECT RESTRICTION LEVEL': 'SELECT RESTRICTION LEVEL',
  'save': 'save',
  'export': 'export',
  'calculate': 'calculate',
  'Run the model to see its visualizations here': 'Run the model to see its visualizations here, Kpi, etc...',
  'from': 'From',
  'Apply': 'Apply',
  'to': 'To',
  'all': 'all',
  'suddenBraking': 'Sudden Braking',
  'speeding': 'Speeding',
  'sharpAccelerations': 'SharpAccelerations',
  'compare': 'compare',
  'Of the interval 1': 'Of the interval 1',
  'with the interva 2': 'With the interva 2',
  'Real Time': 'Real Time',
  'Adecuado': 'Suitable',
  'Alerta nivel medio': 'Medium level alert',
  'Alerta nivel alto': 'High level alert',
  'Listado de paradas': 'List of stops',
  'Modelo': 'Model',
  'Color': 'Color',
  'Categoría': 'Category',
  'Leyenda': 'Legend',
  'Allergens': 'Allergens',
  'last day': 'Last day',
  'last seven days': 'Last 7 days',
  'last thirty days': 'Last 30 days',
  'last twelve months': 'Last 12 months',
  'last five years': 'Last 5 years',
  'Spanish': 'Spanish',
  'English': 'English',
  'Galician': 'Galician',
  'Profile': 'Profile',
  'LogOut': 'Log Out',
  'withoutStage': 'Without Stage',
  'LIMIT': 'LIMIT',
  'ZONE': 'ZONE',
  'withoutRestrictions': 'WITHOUT RESTRICTIONS',
  'ALLVEHICLES': 'ALL VEHICLES',
  'Stage': 'Stage',
  'instalacionesdeportivas': 'Sports facilities',
  'contaminaciónenelaire': 'Air pollution',
  'parkings': {
    'streetAddress': 'Street address',
    'totalSpotNumber': 'Total spot',
    'availableSpotNumber': 'Available spot',
    'occupiedSpot': 'Occupied spot',
    'occupationRate': 'Occupation rate'
  },
  'administration': {
    'roles': {
      'roles': 'Roles',
      'newRole': 'New role',
      'associateUsers': 'Associate users',
      'associatedUsers': 'Associated users',
      'availableUsers': 'Available users'
    },
    'users': {
      'users': 'Users',
      'newUser': 'New user',
      'associatedRoles': 'Associated roles',
      'availableRoles': 'Available roles'
    },
    'general': {
      'name': 'Name',
      'description': 'Description',
      'associatedUsers': 'Associated users',
      'email': 'Email',
      'generalData': 'General data',
      'cancel': 'Cancel',
      'finish': 'Finish'
    },
    'defaultForm': {
      'placeholder': 'Write here',
      'generalData': 'General data',
      'description': 'Description',
      'phone': 'Phone number',
      'password': 'Password',
      'repeatPassword': 'Repeat password',
      'email': 'Email'
    }
  },
  'predictiveModels': {
    'instalacionesdeportivas': 'Sports facilities',
    'contaminaciónenelaire': 'Air pollution',
    'sportInstallationsDescription': 'Forecast of the evolution of air pollution according to restriction levels',
    'pollutionDescription': 'Forecast of the evolution of air pollution according to restriction levels',
    'levelsOf': 'Levels of',
    'inAir': 'in the air',
    'currentScene': 'Current scene',
    'infoScene': 'Information scene',
    'alarmScene': 'Alarm scene',
    'speedLimit': 'Speed limit',
    'centerZone': 'Center zone',
    'allVehicles': 'All vehicles',
    'notRestrictions': 'Without Restrictions',
    'historical': 'Historical',
    'prediction': 'Prediction',
    'alertLevel': 'Alert level',
    'month': 'MONTH',
    'currentMonthLabel': 'CURRENT',
    'levelsCO2': 'NO2 Levels (µg/m3)',
    'type': 'TYPE',
    'ceroEmissions': 'ZERO EMISSIONS',
    'paddel': 'paddel',
    'tennis': 'tennis',
    'soccer': 'soccer',
    'sportcenters': 'Sport centers',
    'search': 'search for',
    'center': 'Center',
    'southzone': 'South Zone',
    'northzone': 'North Zone',
    'occupationinfacilitiesof': 'Occupation in facilities of',
    'actualprice': 'Actual Price',
    'newprice': 'New price',
    'occupationPercentage': 'Ocuppation percentage'
  }
}



// WEBPACK FOOTER //
// ./src/lang/locale/en.js